/*eslint-disable*/

import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, listByProposal, find, save, remove } from '../../services/proposalFile'
import { getProposalID } from '../../services/api'

// The same redux slice serves two screens. Which list to (re)load depends on where
// the user is: the proposal screen shows only the proposal's own files, the work
// order screen shows everything attached to the work order.
function onProposalScreen() {
  return typeof window !== 'undefined' && window.location.pathname.startsWith('/proposals')
}

// Returns undefined when the answer belongs to a proposal the user has already left.
function* loadCurrentList() {
  if (onProposalScreen()) {
    // The proposal on screen (address), not the one still in the store from before.
    const proposalID = getProposalID()
    const files = yield call(listByProposal, proposalID)
    return String(getProposalID()) === String(proposalID) ? files : undefined
  }
  const workOrderID = yield select(state => state.workOrders?.editing?.workOrderID)
  return yield call(list, workOrderID)
}

function* fetchProposalFiles() {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield loadCurrentList()
  if (result === undefined) {
    return
  }
  yield put({
    type: actions.LIST_ProposalFile,
    result,
  })
}

function* fetchProposalFileEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_ProposalFile,
    result,
  })
}

function* fetchProposalFileSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const resultSave = yield call(save, values)
  if (resultSave !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
    const result = yield loadCurrentList()
    if (result !== undefined) {
      yield put({
        type: actions.LIST_ProposalFile,
        result,
      })
    }
  }
}

function* fetchProposalFileDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const resultSave = yield call(remove, values)
  if (resultSave !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
    const result = yield loadCurrentList()
    if (result !== undefined) {
      yield put({
        type: actions.LIST_ProposalFile,
        result,
      })
    }
  }
}

// Work order screen: explicit work order id.
function* fetchProposalFiles2({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, id)
  yield put({
    type: actions.LIST_ProposalFile,
    result,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_ProposalFilesWorkOrder, fetchProposalFiles2),

    takeEvery(actions.FETCH_ProposalFileS, fetchProposalFiles),
    takeEvery(actions.FETCH_ProposalFile, fetchProposalFileEdit),
    takeEvery(actions.SAVE_ProposalFile, fetchProposalFileSave),
    takeEvery(actions.DELETE_ProposalFile, fetchProposalFileDelete),
  ])
}
